import React, { useState } from 'react';
import "./App.css";
import { useNavigate, Link } from 'react-router-dom';
import logoECJ from "./img/ecj-logo.svg";
import logoSvant from "./img/svant-logo.svg";
import { BACKEND_URL } from "./config";

function App() {
  const getStoredValue = (key, defaultValue = '') => {
    return sessionStorage.getItem(key) || defaultValue;
  };

  const setStoredValue = (key, value) => {
    sessionStorage.setItem(key, value);
  };

  const [questionsECJ1, setQuestionsECJ1] = useState(getStoredValue('questions_ECJ_1'));
  const [questionsECJ2, setQuestionsECJ2] = useState(getStoredValue('questions_ECJ_2'));
  const [questionsECJ3, setQuestionsECJ3] = useState(getStoredValue('questions_ECJ_3'));
  const [questionsECJ4, setQuestionsECJ4] = useState(getStoredValue('questions_ECJ_4'));
  const [formErrors, setFormErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState("");

  const navigate = useNavigate();

  const btnBack = () => {
    navigate('/emission');
  };

   const btnNext = async (e) => {
    e.preventDefault();
    const errores = {};
    if (!questionsECJ1.trim()) errores.questionsECJ1 = 'Debe seleccionar una opción para la pregunta';
    if (!questionsECJ2.trim()) errores.questionsECJ2 = 'Debe seleccionar una opción para la pregunta';
    if (!questionsECJ3.trim()) errores.questionsECJ3 = 'Debe seleccionar una opción para la pregunta';
    if (!questionsECJ4.trim()) errores.questionsECJ4 = 'Debe seleccionar una opción para la pregunta';
    setFormErrors(errores);

    if (Object.keys(errores).length > 0) return;

  try {
    setSubmitting(true);
    setSubmitError("");

    const payload = collectPayload();

    const res = await fetch(`${BACKEND_URL}/responses`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    if (!res.ok) throw new Error("server_error");
    const data = await res.json();
    
    if (typeof data?.co2_total_per_user === "number") {
      localStorage.setItem("emissions_kg_co2e", String(data.co2_total_per_user));
    }

    if (data && data.user_id) {
      localStorage.setItem("user_id", String(data.user_id));
    }

 if (data?.status === "error") {
     setSubmitError(data?.message || "No pudimos procesar tu inscripción.");
     return;
   }

   if (data?.status === "ok" && data?.user_id) {
     if (data.is_invited) {
       try {
         await fetch(`${BACKEND_URL}/confirm-invited`, {
           method: "POST",
           headers: { "Content-Type": "application/json" },
           body: JSON.stringify({ id_user_response: data.user_id }),
         });
       } catch (_) {}
       navigate("/thanks");
       return;
     }


     const AMOUNT_CENTS = 18500000; 
     const sp = await fetch(`${BACKEND_URL}/start-payment`, {
       method: "POST",
       headers: { "Content-Type": "application/json" },
       body: JSON.stringify({
         email: sessionStorage.getItem("email"),
         amount: AMOUNT_CENTS,
         id_user_response: data.user_id,
       }),
     });
     const spData = await sp.json();
     const mpUrl = spData.payment_url || spData.init_point || spData.preference_url;
     if (mpUrl) {
       window.location.href = mpUrl;
       return;
     }
     setSubmitError("No se pudo iniciar el pago. Probá nuevamente.");
     return;
   }

   setSubmitError("No pudimos procesar tu inscripción.");
  } catch (err) {
    console.error(err);
    setSubmitError("Ocurrió un error enviando tu inscripción. Probá nuevamente.");
  } finally {
    setSubmitting(false);
  }
};


const collectPayload = () => {
  const pick = (k, def = "") => sessionStorage.getItem(k) || def;
  const toNum = (v) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : 0;
  };

  const hotelFlag = toNum(pick("stayed_in_hotel")); 
  const nights    = toNum(pick("hotel_nights"));  

  return {
    
    first_name: pick("first_name"),
    last_name: pick("last_name"),
    dni: pick("dni"),
    email: pick("email"),
    phone: pick("phone"),
    position: pick("position"),
    region: pick("region"),
    sector: pick("sector"),
    employees: pick("employees"),
    id_company: pick("id_company") ? parseInt(pick("id_company"), 10) : null,
    company_name: pick("company_name") || null,
    invitation_code: (pick("invitation_code") || "").toUpperCase() || null,

    air_travel: pick("air_travel"),
    travel_time: toNum(pick("travel_time")),
    event_transport: pick("event_transport"),
    km_land: toNum(pick("km_land")),
    
    stayed_in_hotel: hotelFlag,
    hotel_nights: hotelFlag ? nights : 0,

    
    extra_answers: {
      questions_emissions_1: pick("questions_emissions_1"),
      questions_emissions_2: pick("questions_emissions_2"),
      questions_emissions_3: pick("questions_emissions_3"),
      questions_ECJ_1: pick("questions_ECJ_1"),
      questions_ECJ_2: pick("questions_ECJ_2"),
      questions_ECJ_3: pick("questions_ECJ_3"),
      questions_ECJ_4: pick("questions_ECJ_4"),
    },
  };
};

  return (
    <div className='container'>
      <div className='flexBetween'>
        <img
          className='logoECJ'
          src={logoECJ}
          alt="EconoJournal"
        />
        <img
          className='logoSvant'
          src={logoSvant}
          alt="Svant Measure and Act"
        />
      </div>
      <h2>Formulario de público</h2>
      <h4>Esta información será utilizada para comprender la situación que detectan nuestros participantes y elaborar informes periodísticos.</h4>
      <form onSubmit={btnNext}>
        <div className='containerFlex'>
            <label>Con relación a las reformas del sector eléctrico que está impulsando el gobierno —tendientes a favorecer la recontractualización entre privados y la creación de un nuevo Mercado a Término (MAT), así como también la descentralización de gestión de combustibles en el parque de generación—, ¿qué grado de probabilidad le asignás a estos cambios? <b>*</b></label>
            <select
              value={questionsECJ1}
              name='questions_ECJ_1'
              onChange={(e) => {
                setQuestionsECJ1(e.target.value);
                setStoredValue('questions_ECJ_1', e.target.value);
              }}
            >
              <option value="" disabled>Seleccioná una opción</option>
              <option value="Alta">Alta</option>
              <option value="Media">Mediana, llevará más tiempo del previsto</option>
              <option value="Baja">Baja, la volatilidad macroeconómica dificultará su implementación</option>
            </select>
            {formErrors.questionsECJ1 && <span className="required">{formErrors.questionsECJ1}</span>}

            <label>Si tuvieses que elegir una opción en función de su criticidad, ¿Qué segmento del mercado eléctrico debería priorizar el gobierno para viabilizar el desarrollo integral del sector a mediano-largo plazo? <b>*</b></label>
            <select
              value={questionsECJ2}
              name='questions_ECJ_2'
              onChange={(e) => {
                setQuestionsECJ2(e.target.value);
                setStoredValue('questions_ECJ_2', e.target.value);
              }}
            >
              <option value="" disabled>Seleccioná una opción</option>
              <option value="Transporte">Ampliar la red de transporte eléctrico</option>
              <option value="Generación">Instrumentar esquemas para construir nuevas centrales de generación</option>
              <option value="Almacenamiento">Fomentar la instalación de más capacidad de almacenamiento</option>
              <option value="Otro">Otro</option>
            </select>
            {formErrors.questionsECJ2 && <span className="required">{formErrors.questionsECJ2}</span>}
        </div>

        <div className='containerFlex'>
            <label>¿Cómo imaginás el desempeño del sector de energías renovables en la Argentina durante los próximos cinco años? <b>*</b></label>
            <select
              value={questionsECJ3}
              name='questions_ECJ_3'
              onChange={(e) => {
                setQuestionsECJ3(e.target.value);
                setStoredValue('questions_ECJ_3', e.target.value);
              }}
            >
              <option value="" disabled>Seleccioná una opción</option>
              <option value="Crecimiento">Confío en un crecimiento significativo a partir de la apertura del mercado eléctrico</option>
              <option value="Amesetamiento">Visualizo un amesetamiento por falta de infraestructura de transporte</option>
              <option value="Caída">Me preocupa una caída de la inversión por falta de incentivos</option>
              <option value="Otro">Otro</option>
            </select>
            {formErrors.questionsECJ3 && <span className="required">{formErrors.questionsECJ3}</span>}

            <label>¿Creés que la Argentina podrá acceder a financiamiento a tasas competitivas para financiar proyectos en el sector de energía eléctrica? <b>*</b></label>
            <select
              value={questionsECJ4}
              name='questions_ECJ_4'
              onChange={(e) => {
                setQuestionsECJ4(e.target.value);
                setStoredValue('questions_ECJ_4', e.target.value);
              }}      
            >
              <option value="" disabled>Seleccioná una opción</option>
              <option value="Si">Sí</option>
              <option value="No">No</option>
              <option value="No sabe">NS/NC</option>
            </select>
            {formErrors.questionsECJ4 && <span className="required">{formErrors.questionsECJ4}</span>}
        </div>

        <div>
          <p className='legal'>*Los campos son requeridos</p>
        </div>

        <div className='containerFlex'>
          <div className='card flexBetween'>
            <div>
              <p className='legal'>Al enviar este formulario, aceptás nuestra <Link to='/privacy' target='blank'>Política de Privacidad.</Link></p>
            </div>
            {submitError && (
              <p className="required" style={{ marginTop: 8 }}>
                {submitError}
              </p>
            )}

            <div>
              <button type="button" onClick={btnBack}>Volver</button>
              <button type="submit" disabled={submitting} aria-busy={submitting}>
                {submitting ? "Enviando..." : "Confirmar"}
              </button>
            </div>
          </div>
        </div>

        <h4 className="footerCopyright">Design, code, words, and hard work by <Link to="https://wcm.media" target="blank">Wildcat Media.</Link></h4>
      </form>
    </div>
  );
}

export default App;